import { create } from 'zustand';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/india/calendar`;

export const useCalendarStore = create((set, get) => ({
  corpActions: [],
  earnings: [],
  loading: false,
  error: null,
  month: new Date().getMonth() + 1,
  year: new Date().getFullYear(),

  setMonth: (month, year) => {
    set({ month, year });
    const { activeTab } = get();
    if (activeTab === 'earnings') get().fetchEarnings(month, year);
    else get().fetchCorpActions(month, year);
  },

  activeTab: 'corp-actions',
  setActiveTab: (tab) => {
    set({ activeTab: tab });
    const { month, year } = get();
    if (tab === 'earnings') get().fetchEarnings(month, year);
    else get().fetchCorpActions(month, year);
  },

  fetchCorpActions: async (month, year) => {
    set({ loading: true, error: null });
    try {
      const m = month || get().month;
      const y = year || get().year;
      const res = await fetch(`${API}/corporate-actions?month=${m}&year=${y}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      set({ corpActions: data.events || [], loading: false, month: m, year: y });
    } catch (err) {
      set({ loading: false, error: err.message });
    }
  },

  fetchEarnings: async (month, year) => {
    set({ loading: true, error: null });
    try {
      const m = month || get().month;
      const y = year || get().year;
      const res = await fetch(`${API}/earnings?month=${m}&year=${y}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      set({ earnings: data.events || [], loading: false, month: m, year: y });
    } catch (err) {
      set({ loading: false, error: err.message });
    }
  },
}));
